import { render, staticRenderFns } from "./PlotType.vue?vue&type=template&id=240cdb40&"
import script from "./PlotType.vue?vue&type=script&lang=js&"
export * from "./PlotType.vue?vue&type=script&lang=js&"
import style0 from "./PlotType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports